import toRegex from 'path-to-regexp';

function matchURI(path, uri) {
  const keys = [];
  const pattern = toRegex(path, keys);
  const match = pattern.exec(uri);
  if (!match) return null;
  const params = Object.create(null);
  for (let i = 1; i < match.length; i++) {
    params[keys[i - 1].name] = match[i] !== undefined ? match[i] : undefined;
  }
  return params;
}

function resolve(routes, location) {
  for (const route of routes) {
    const uri = location.error ? '/error' : location.pathname;
    const params = matchURI(route.path, uri);
    if (!params) continue;
    return { route, params };
  }
}

export default resolve;
